import { make } from 'vuex-pathify'

const state = {
  display: false,
  message: ''
}

const mutations = {
  SET_SHOW: (state, message) => {
    state.display = !state.display
    state.message = message
  },
  SET_HIDE: state => {
    state.display = false
  }
}

const actions = {
  show({ commit }, message) {
    commit('SET_SHOW', message)

    setTimeout(() => {
      commit('SET_HIDE')
    }, 3000)
  },
  hide({ commit }) {
    commit('SET_HIDE')
  }
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
